import config from "../../config/config.json";
import { headers } from "../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody
} from "../../APIHelpers/Responses";

export const clientServices = {
  statusUpdateVaultClient,
  getSingleVaultClient,
  getVaultClients,
};

// Status Update Client
async function statusUpdateVaultClient(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}statusUpdateVaultClient`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  if(!userData?.bookmarkType){
    handleResponse(data)
  }
  return data;
}

// Get All Clients
async function getVaultClients(status, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getVaultClients/${status}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getVaultClients/${status}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Get Single Client Data
async function getSingleVaultClient(userId) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getSingleVaultClient/${userId}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}